module.exports = __webpack_public_path__ + "img/GordonFreemanPhD.d3cb0f56.png";